<template>
    <div class="approve_admin_base_info_wrap">
        <el-form :model="baseInfoForm" :rules="baseInfoFormRules"  label-position="top"  ref="baseInfoForm" size="small">
            <el-form-item label="图标" prop="icon">
                <div class="flex flex-align">
                    <img :src="baseInfoForm.icon" alt="" v-if="baseInfoForm.icon" width="44" class="icon">
                    <el-popover placement="bottom-start"   ref="iconPopover"
                                trigger="click"  width="535">
                        <el-button slot="reference" type="text">{{baseInfoForm.icon ? '修改' : '修改'}}</el-button>
                        <ul class="approval_icon_option_list">
                            <li  @click="handleClickClickIcon(item)"  class="icon_option_item"  v-for="(item,index) in iconOptionList"> <img :src="item" alt="">
                            </li>
                        </ul>
                    </el-popover>
                </div>
            </el-form-item>
            <el-form-item label="审批名称" prop="name">
                <el-input  placeholder="请输入审批名称" v-model="baseInfoForm.name"  @change="haveEditedBefore"></el-input>
            </el-form-item>
            <el-form-item category_id label="所在分组" prop="category_id">
                <el-select placeholder="请选择所在分组" v-model="baseInfoForm.category_id" filterable @change="haveEditedBefore">
                    <el-option  v-for="item in approvalCateList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="可以提交该审批的人员" prop="eligible_users">
                <el-select :popper-append-to-body="false"
                           @clear="handleClickClearPromoter()"
                           @focus="handleClickPromoter()"
                           @remove-tag="handleClickRemovePromoter($event)"
                           clearable collapse-tags
                           multiple
                           placeholder="请选择可以提交该审批的人员"
                           popper-class="selectPopperHideClass"
                           ref="selectPromoter"
                           v-model.trim="baseInfoForm.eligible_user_ids">
                    <el-option v-for="item in baseInfoForm.eligible_users" :value="item.relate_type_id" :label="item.relate_name" ></el-option>
                </el-select>
                <p class="hint">不设置则默认全员可见</p>
            </el-form-item>

        </el-form>
        <userDepartmentSelection :userDepartmentVisible.sync="userDepartmentVisible" v-if="userDepartmentVisible" :userDepartmentSelected="baseInfoForm.eligible_users" :userDepartmentTitle="'选择人员'" :type="'userDepartment'" :checkStrictly="true" @success="userDepartmentSuccess"/>
    </div>
</template>
<script>
import {calculateLength} from '@/utils'
import { approvalSetList} from "@/api/index.js"
import userDepartmentSelection from "@/components/pComponents/userDepartmentSelection.vue";
export default {
    name: "ApproveAdminBaseInfo",
    components: {
        userDepartmentSelection
    },
     props: {
        base_info: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            baseInfoForm: {
                icon: "https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png",
                name: "",
                category_id: "",
                eligible_users: [],
                eligible_user_ids:[],
                type: ""
            },
            baseInfoFormRules: {
                 icon: [{required: true, message: '请选择图标', trigger: 'blur'}],
                 name: [{required: true, trigger: 'change',validator: (rule, value, callback) => {
                        if(!value) return  callback(new Error('请输入审批名称'))
                        if(calculateLength(value) > 10)return  callback(new Error('审批名称不可超过10个字符'))
                        callback()
                 }}],
                 category_id: [{required: true, message: '请选择所在分组', trigger: 'change'}],
            },
            iconOptionList:[
                'https://download.hecoos.com/enlightv/2025-12/b39651b6ed9bbd4cc5c9ade2c64dfd33.png',//审批1
                'https://download.hecoos.com/enlightv/2025-12/d4e5b1ba8501f7bc00eab39618d81d34.png',//审批2
                'https://download.hecoos.com/enlightv/2025-11/a433f483ae823c9a0309080915113e44.jpg',//审批3
                'https://download.hecoos.com/enlightv/2025-12/bd0c9bff3b4e9a9df04e7e8a79f67fc1.png',//审批4
                'https://download.hecoos.com/enlightv/2025-12/5251395be0d2ccbb6186c46247807f4a.png',//审批5
                'https://download.hecoos.com/enlightv/2025-12/96e48ff155d3bb6288b07ed696d98520.png',//审批6
                'https://download.hecoos.com/enlightv/2025-12/80b0592ee997d68beacbe1ba7f3dc29a.png',//审批7
                'https://download.hecoos.com/enlightv/2025-12/9cc3268ea8b0b2585699ae658debfc1f.png',//审批8
                'https://download.hecoos.com/enlightv/2025-12/08a10f3514e131ef7cdf07048f6ce514.png',//审批9
                'https://download.hecoos.com/enlightv/2025-12/1fce6e3355becb317cfb5149260231df.png',//审批10
                'https://download.hecoos.com/enlightv/2025-11/4d4e2dcf36273f2cc772c4ab00f89a5c.jpg', //报价单
                'https://download.hecoos.com/enlightv/2025-11/34dcd14250577213462df7879e4b2f77.jpg', //报销申请
                'https://download.hecoos.com/enlightv/2025-11/3b23a24bba502b3ee5afbf719c86b22a.jpg', //采购申请
                'https://download.hecoos.com/enlightv/2025-11/f97dc7e91266fe2d71360ec31a69e0ab.jpg', //产品上架
                'https://download.hecoos.com/enlightv/2025-11/b37b1d4132b45d3743f0a313bde4cce6.jpg', //出库
                'https://download.hecoos.com/enlightv/2025-11/6d2a7c090ea745eb5a395d03b19c890e.jpg', //订单提成
                'https://download.hecoos.com/enlightv/2025-11/1c7642be75e4cddf4c400e9be2de9c77.jpg', //订单退款
                'https://download.hecoos.com/enlightv/2025-11/b48056a463b9f243b6b9f11ae17a42d1.jpg', //付款申请
                'https://download.hecoos.com/enlightv/2025-11/1673aeb2f72141c35aaf481c7357f180.jpg', //工单激励
                'https://download.hecoos.com/enlightv/2025-11/be9523973dbf4a5b961178c460092731.jpg', //工单结单
                'https://download.hecoos.com/enlightv/2025-11/83597ba153c530585176022df675fd7f.jpg', //归还
                'https://download.hecoos.com/enlightv/2025-11/0b43d0e93e60876f6ad0d8b7786e55b5.jpg', //换货
                'https://download.hecoos.com/enlightv/2025-11/19648de63a529a37e09509c10f59fa62.jpg', //计划提成
                'https://download.hecoos.com/enlightv/2025-11/ddddf44ff108566719b465133181511e.jpg', //考勤
                'https://download.hecoos.com/enlightv/2025-11/5ffa2d32824baf30796dd0519835fef4.jpg', //客户申领
                'https://download.hecoos.com/enlightv/2025-11/a4a2088b4fae33d1753f102f3a4f40e2.jpg', //任务管理
                'https://download.hecoos.com/enlightv/2025-11/349def6a5e1fe43e2d196edcc1dc575b.jpg', //日程表
                'https://download.hecoos.com/enlightv/2025-11/534a77da943a66553fb29d724506b9c7.jpg', //日志
                'https://download.hecoos.com/enlightv/2025-11/a494088109c114bca559e0bb4541e491.jpg', //入库
                'https://download.hecoos.com/enlightv/2025-11/bbbb0c1b791c4572a426e426eb6e347e.jpg', //商机报备
                'https://download.hecoos.com/enlightv/2025-11/e187264b0b644ecfeeb59dbf6edc7d2d.jpg', //设备归还
                'https://download.hecoos.com/enlightv/2025-11/54b7bf4676654287ff2323f8b0883a3c.jpg', //授权
                'https://download.hecoos.com/enlightv/2025-11/c3a81d970c6a616596c09d00651adc3f.jpg', //售后
                'https://download.hecoos.com/enlightv/2025-11/2e9cbd03bb64432ce8d9e83e20ef89df.jpg', //售后-销售订单编辑
                'https://download.hecoos.com/enlightv/2025-11/8890cf1cd9c20607e1d739bdc70909ee.jpg', //售后-租借订单编辑
                'https://download.hecoos.com/enlightv/2025-11/0f367d562878eb21f85f739009c21f66.jpg', //提成汇总
                'https://download.hecoos.com/enlightv/2025-11/e2a67d0abc5b2f1b87f1e3ef2d74e18f.jpg', //添加审批
                'https://download.hecoos.com/enlightv/2025-11/17d0740cac2fd2a3cf47ac60c072e9ba.jpg', //填写日志
                'https://download.hecoos.com/enlightv/2025-11/054d91e8d10d291d86b2f2ec2554a2b9.jpg', //退货
                'https://download.hecoos.com/enlightv/2025-11/d28acb421c6b47f694c4e81a7f0575ad.jpg', //退款
                'https://download.hecoos.com/enlightv/2025-11/baed4e1d8925ed41ebe99d66a1d9d17e.jpg', //物品领用
                'https://download.hecoos.com/enlightv/2025-11/5b36d75389852ed36128da2edf4559ff.jpg', //项目设计
                'https://download.hecoos.com/enlightv/2025-11/2b1eb3034573e7e1a56806f59c3887f2.jpg', //销售订单
                'https://download.hecoos.com/enlightv/2025-11/844f3a3cb19e0320decf70b83fa52ea3.jpg', //销售客户
                'https://download.hecoos.com/enlightv/2025-11/34ed1b2f92098883f344f21f0134809c.jpg', //小程序
                'https://download.hecoos.com/enlightv/2025-11/f89f033a0dfbed0cf53ed85ffacd5c59.jpg', //小程序订单后台（租赁）
                'https://download.hecoos.com/enlightv/2025-11/89876a72f1a2c0a07ed4435f093f0995.jpg', //小程序订单后台确认（销售）
                'https://download.hecoos.com/enlightv/2025-11/50a1a705efba12af5482b2db9709ade6.jpg', //小程序租赁发货申请
                'https://download.hecoos.com/enlightv/2025-11/633bc9ab7b32fba79bcf03bdebff24c1.jpg', //续租
                'https://download.hecoos.com/enlightv/2025-11/0b83954431adbb4f22407be57ee0b009.jpg', //延期回收申请
                'https://download.hecoos.com/enlightv/2025-11/cd2417ede60eb4bbd81be495cc0d3eb0.jpg', //赠送出库
                'https://download.hecoos.com/enlightv/2025-11/46a82ad414ea74295c32bd22decbb967.jpg', //资产划拨
                'https://download.hecoos.com/enlightv/2025-11/f3973f2fa86558705e174ac2f4b93330.jpg', //租借转销售
                'https://download.hecoos.com/enlightv/2025-11/cfc1b03d0cc888c4a18a04850ac70171.jpg', //租赁订单
                'https://download.hecoos.com/enlightv/2025-11/e8bd7fa6b2eb35a041e4c89608fba6dd.jpg', //租赁客户

                'https://download.hecoos.com/enlightv/2025-12/9b70a6fb43f63fb12e3c74e3128fd9ee.png', //差旅申请
                'https://download.hecoos.com/enlightv/2025-12/948faed8e7897d5fd5bc8c63042cebe7.png',//调岗申请
                'https://download.hecoos.com/enlightv/2025-12/13b4564fe679077b28461342c0dc7aeb.png',//加班申请
                'https://download.hecoos.com/enlightv/2025-12/e881c6481a8be3b05d0cdf87921036f5.png',//离职申请
                'https://download.hecoos.com/enlightv/2025-12/cd69546455536ac6702e5515ec3d632b.png',//内部培训
                'https://download.hecoos.com/enlightv/2025-12/d047a2a80b0c6fe4f6bfa85d8806b458.png',//请假申请
                'https://download.hecoos.com/enlightv/2025-12/4c7d30f5752ef1498fa791fa7c03def6.png',//入职申请.

                'https://download.hecoos.com/enlightv/2025-12/1f5f0521dc49431dd769693041ebf31b.png',//外出申请
                'https://download.hecoos.com/enlightv/2025-12/ed28c6e6ad27a314136da5caf03f95f7.png',//招聘申请
                'https://download.hecoos.com/enlightv/2025-12/53bb7f14155578ffbca4e6d629d9e2d2.png',//转正审批



            ],
            approvalCateList:[],
            userList:[],
            userDepartmentVisible:false,
            is_edit_flag:false
        }
    },
    created() {
        if(this.base_info && this.base_info.id){
            this.baseInfoForm =  {
                icon: this.base_info.icon,
                name: this.base_info.name,
                category_id: this.base_info.category_id,
                eligible_users:this.base_info.eligible_users,
                eligible_user_ids:this.base_info.eligible_users.map((map)=> {return map.relate_type_id}),
                type: this.base_info.type,
            }
        }
        this.getApprovalCateData()
    },
    methods: {
        getApprovalCateData(){
            approvalSetList().then(res=> {
                if(res.code === 200) {
                    this.approvalCateList = res.data
                }
            })
        },
        // 选择图标
        handleClickClickIcon(icon){
            this.baseInfoForm.icon = icon
            this.$refs.iconPopover.doClose()
            this.$refs.baseInfoForm.validateField('icon')
            this.haveEditedBefore()
        },

        handleClickClearPromoter() {
            this.baseInfoForm.eligible_users = []
            this.baseInfoForm.eligible_user_ids = []
            this.haveEditedBefore()
        },

        handleClickPromoter() {
           this.userDepartmentVisible = true
        },

        // 点击删除
        handleClickRemovePromoter(tag) {
            this.baseInfoForm.eligible_users.forEach((item, index) => {
                if (item.relate_type_id == tag) {
                    this.baseInfoForm.eligible_users.splice(index, 1)
                }
            })
            this.haveEditedBefore()
        },
        // 选择部门人员回调
        userDepartmentSuccess(data){
            this.baseInfoForm.eligible_users = data
            this.baseInfoForm.eligible_user_ids = data.map((item)=>{
                return item.relate_type_id
            })
           this.haveEditedBefore()
        },
        // 是否编辑了
        haveEditedBefore(){
            this.$emit('editSuccess', true)
        }


    },
    watch: {

    }
}
</script>
<style lang="scss" scoped>
    @import "@/styles/approval.scss";
</style>
